import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Page from '../../components/Page';
import DashboardLayout from "../../layouts/DashboardLayout";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '80%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    paddingTop: 80,
    paddingBottom: 80
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  }
}));

function Error401View() {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

  return (
      <DashboardLayout>
        <Page
          className={classes.root}
          title="Session Expired"
        >
          <Container maxWidth="lg">
            <Typography
              align="center"
              variant={'h5'}
              color="textPrimary"
            >
              Your session has expired
            </Typography>
            <Box
              mt={4}
              display="flex"
              justifyContent="center"
            >
              <Button
                color="secondary"
                component={RouterLink}
                to="/"
                variant="contained"
                size="large"
              >
                Start Enquiry
              </Button>
            </Box>
          </Container>
        </Page>
      </DashboardLayout>
  );
}

export default Error401View;
